import React, { useEffect } from "react";
import Preloader from "../helper/Preloader";
import HeaderTwo from "../components/Header";
import Breadcrumb from "../components/Breadcrumb";
import ShopSection from "../components/ShopSection";
import ShippingTwo from "../components/ShippingTwo";
import FooterTwo from "../components/Footer";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { fetchCategoryWiseProduct } from "../features/categories/categoryWiseProductSlice";

const ShopPage = () => {
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const {category_details, loading, error} = useSelector((state) => state.category_details)

  useEffect(() => {
    if(params.id) {
      dispatch(fetchCategoryWiseProduct(params.id))
    }
    
    setSearchParams("?with_products=1");
  }, [params.id])

  return (
    <>
    {
      loading ? (
        <> 
          <ColorInit color={true} />
          <ScrollToTop smooth color="#FA6400" />
          <Preloader />
        </>
      ) : (
        <> 
          <Breadcrumb title={"Shop"} />
          <ShopSection category_details={category_details} />
          <ShippingTwo />
        </>
      )
    }
    </>
  );
};

export default ShopPage;
